'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _cards = require('../cards');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EMPTY_CONTENT = 'No blocks available.';

var styles = function styles(theme) {
  return {
    empty: {
      width: '100%',
      height: 100,
      padding: 20,
      textAlign: 'center',
      fontSize: 16,
      fontStyle: 'italic'
    },
    error: {
      border: [[3, 'solid', theme.reject]]
    }
  };
};

var Text = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  _createClass(Text, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          classes = _props.classes,
          cardProps = _objectWithoutProperties(_props, ['content', 'config', 'classes']);

      var _config$blocks = config.blocks,
          blocks = _config$blocks === undefined ? [] : _config$blocks;

      var empty = _react2["default"].createElement('div', {
        className: classes.empty
      }, EMPTY_CONTENT);

      return _react2["default"].createElement(_react.Fragment, null, !blocks.length && empty, blocks.map(function (_ref, i) {
        var view_id = _ref.view_id,
            html_template = _ref.html_template,
            labels = _ref.labels,
            overrides = _objectWithoutProperties(_ref, ['view_id', 'html_template', 'labels']);

        var Component = view_id == 'blocks' ? null : _cards.INTERFACES[view_id];
        return Component ? _react2["default"].createElement(Component, _extends({
          content: _extends({}, content, overrides),
          config: _extends({}, config, {
            htmlTemplate: html_template || config.html_template,
            labels: labels || config.labels
          })
        }, cardProps, {
          key: i
        })) : _react2["default"].createElement('div', {
          className: (0, _classnames2["default"])(classes.empty, classes.error)
        }, 'Not a valid view ID: ', _react2["default"].createElement('strong', null, view_id), '. Available options:', ' ', Object.keys(_cards.INTERFACES).filter(function (v) {
          return v != 'blocks';
        }).join(', '), '.');
      }));
    }
  }]);

  return Text;
}(_react2["default"].Component), _class2.id = 'blocks', _temp)) || _class);
exports["default"] = Text;